<div class="grid-container">
  <div *ngIf="isInternalUser" class="grid-item">
    <app-mdm-input outsideLabel="Product Key"
                   [selectLimit]="5"
                   [minimumLength]="3"
                   placeholder="Key"
                   [fieldType]="integerField"
                   [(chips)]="selectedProductKeys"
                   (selectionChanged)="dataUpdate()"
                   id="productKey">
    </app-mdm-input>
  </div>
  <div class="grid-item">
    <app-mdm-input outsideLabel="Vendor Part Number"
                   [selectLimit]="5"
                   [minimumLength]="3"
                   placeholder="Part Number"
                   [(chips)]="selectedVendorPartNumbers"
                   (selectionChanged)="dataUpdate()"
                   id="vendorPartNumber">
    </app-mdm-input>
  </div>
  <div class="grid-item">
    <app-mdm-input *ngIf="vendorsLoaded"
                   [minimumFilterLength]="2"
                   outsideLabel="Vendor Name"
                   [scrollChips]="false"
                   [selectLimit]="10"
                   searchPlaceholderText="Search for (2 character minimum)"
                   [dropDownSelect]="true"
                   [dropDownData]="vendors"
                   [(chips)]="selectedVendorNames"
                   (selectionChanged)="dataUpdate()"
                   id="vendorName">
    </app-mdm-input>
    <span *ngIf="!vendorsLoaded">Vendors Loading...</span>
  </div>
  <div class="grid-item">
    <app-mdm-input outsideLabel="Vendor Product Description"
                   [selectLimit]="1"
                   [minimumLength]="3"
                   placeholder="Part Description"
                   [maxChipTextLength]="45"
                   [(chips)]="selectedVendorProductDescriptions"
                   (selectionChanged)="dataUpdate()"
                   id="vendorProductDescription">
    </app-mdm-input>
  </div>

  <div class="grid-item">
    <app-mdm-input *ngIf="pscDescriptionsLoaded"
                   outsideLabel="Vizient Contract Category"
                   [selectLimit]="1"
                   [minimumLength]="3"
                   [dropDownSelect]="true"
                   [dropDownData]="pscDescriptions"
                   [(chips)]="selectedPscCategories"
                   [singleSelect]="true"
                   [maxChipTextLength]="45"
                   (selectionChanged)="dataUpdate()"
                   [disabled]="disableSecondary()"
                   id="productSpendCategory">
    </app-mdm-input>
    <span *ngIf="!pscDescriptionsLoaded">PSC Descriptions Loading...</span>
  </div>
  <div class="grid-item">
    <app-mdm-input outsideLabel="UNSPSC Category"
                   [selectLimit]="1"
                   [dropDownSelect]="true"
                   [dropDownData]="unspscCodes"
                   [(chips)]="selectedUnspscCodes"
                   [singleSelect]="true"
                   searchPlaceholderText="Search for (3 character minimum)"
                   [minimumFilterLength]="3"
                   [maxChipTextLength]="45"
                   (selectionChanged)="dataUpdate()"
                   [disabled]="disableSecondary()"
                   id="unspscCategory">
    </app-mdm-input>
  </div>
  <div *ngIf="isInternalUser" class="grid-item">
    <app-mdm-input *ngIf="syncCodesLoaded"
                   outsideLabel="VSC Group Description"
                   [selectLimit]="1"
                   [minimumLength]="3"
                   [dropDownSelect]="true"
                   [dropDownData]="syncCodeGroupDescriptions"
                   [(chips)]="selectedSyncCodeGroupDescriptions"
                   [singleSelect]="true"
                   [maxChipTextLength]="45"
                   (selectionChanged)="dataUpdate()"
                   [disabled]="disableSecondary()"
                   id="syncGroupDescription">
    </app-mdm-input>
    <span *ngIf="!syncCodesLoaded">Vizient Codes Loading...</span>
  </div>
  <div *ngIf="isInternalUser" class="grid-item">
    <app-mdm-input *ngIf="syncCodesLoaded"
                   outsideLabel="VSC Subcategory Description"
                   [selectLimit]="1"
                   [minimumLength]="3"
                   [dropDownSelect]="true"
                   [dropDownData]="syncCodeSubCategoryDescriptions"
                   [(chips)]="selectedSyncCodeSubCategoryDescriptions"
                   [singleSelect]="true"
                   [maxChipTextLength]="45"
                   (selectionChanged)="dataUpdate()"
                   [disabled]="disableSecondary()"
                   id="syncSubcategoryDescription">
    </app-mdm-input>
    <span *ngIf="!syncCodesLoaded">Vizient Codes Loading...</span>
  </div>

  <div *ngIf="isInternalUser" class="grid-item">
    <app-mdm-input outsideLabel="Contract Number"
                   [selectLimit]="5"
                   [minimumLength]="3"
                   placeholder="Contract Number"
                   [(chips)]="selectedContractNumbers"
                   [maxChipTextLength]="45"
                   (selectionChanged)="dataUpdate()"
                   id="contractNumber">
    </app-mdm-input>
  </div>
  <div class="grid-item">
    <app-mdm-input outsideLabel="On National Contract"
                   [selectLimit]="1"
                   [dropDownSelect]="true"
                   [dropDownData]="yesNoDropdownNationalContract"
                   [(chips)]="selectedOnNationalContract"
                   [singleSelect]="true"
                   [allowSearchFilter]="false"
                   (selectionChanged)="dataUpdate()"
                   [disabled]="disableSecondary()"
                   id="onNationalContract">
    </app-mdm-input>
  </div>




  <div *ngIf="isInternalUser" class="grid-item">
    <app-mdm-input outsideLabel="Batch"
                   [selectLimit]="1"
                   placeholder="Batch Number"
                   [maxChipTextLength]="45"
                   [(chips)]="selectedBatchIds"
                   id="batch">
    </app-mdm-input>
  </div>
  <div class="grid-item">
    <app-mdm-input outsideLabel="Confidence Label"
                   [selectLimit]="1"
                   [dropDownSelect]="true"
                   [dropDownData]="confidenceLabels"
                   [(chips)]="selectedConfidenceLabels"
                   [singleSelect]="true"
                   [maxChipTextLength]="45"
                   [allowSearchFilter]="false"
                   (selectionChanged)="dataUpdate()"
                   [disabled]="disableSecondary()"
                   id="confidenceLabel">
    </app-mdm-input>
  </div>
  <div *ngIf="isInternalUser" class="grid-item">
    <app-mdm-input outsideLabel="Source"
                   [selectLimit]="1"
                   [dropDownSelect]="true"
                   [dropDownData]="possibleSources"
                   [(chips)]="selectedSources"
                   [singleSelect]="true"
                   [allowSearchFilter]="false"
                   [maxChipTextLength]="45"
                   (selectionChanged)="dataUpdate()"
                   [disabled]="disableSecondary()"
                   id="source">
    </app-mdm-input>
  </div>
  <div *ngIf="isInternalUser" class="grid-item">
    <app-mdm-input outsideLabel="Reviewed"
                   [selectLimit]="1"
                   [dropDownSelect]="true"
                   [dropDownData]="yesNoDropdownReviewed"
                   [(chips)]="selectedReviewed"
                   [singleSelect]="true"
                   [allowSearchFilter]="false"
                   (selectionChanged)="dataUpdate()"
                   [disabled]="disableSecondary()"
                   id="reviewed">
    </app-mdm-input>
  </div>
</div>
<span class="parameterbuttons">
  <button class="clearparameterbutton" [disabled]="disableSecondary()" mat-raised-button color="primary" (click)="clearParameters()" id="clearParametersButton">Clear Parameters</button>
  <button class="cancelsearchbutton" *ngIf="searchInProgress" mat-raised-button color="primary" (click)="cancelSearch()" id="cancelSearchButton">Cancel Search</button>
  <button *ngIf="!searchInProgress" [disabled]="disableSecondary()" mat-raised-button color="primary" (click)="searchClick()" id="searchButton">Search</button>
</span>

